import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  TestCase,
  TestCaseBody
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  modelId: string
  testCaseId: string
  onError?: (error: Error) => void
  onSuccess?: (data: TestCase) => void
  children?: (data: TestCase) => ReactElement
  params: TestCaseBody
}

const UpdateModelerModelTestCaseRequest = ({
  modelId,
  testCaseId,
  onError,
  onSuccess,
  children,
  params
}: Props) => {
  const url = `${MODELER_SERVICE}/models/${modelId}/test_cases/${testCaseId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateModelerModelTestCaseRequest
